'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = publishErrors;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function publishErrors() {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      (0, _inherits3.default)(PublishErrorsWrapper, _React$Component);

      function PublishErrorsWrapper() {
        (0, _classCallCheck3.default)(this, PublishErrorsWrapper);
        return (0, _possibleConstructorReturn3.default)(this, (PublishErrorsWrapper.__proto__ || (0, _getPrototypeOf2.default)(PublishErrorsWrapper)).apply(this, arguments));
      }

      (0, _createClass3.default)(PublishErrorsWrapper, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, {
            publishError: this.context.publishError
          }));
        }
      }]);
      return PublishErrorsWrapper;
    }(_react2.default.Component), _class.contextTypes = {
      publishError: _react2.default.PropTypes.func
    }, _temp;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/publishErrors.js
// module id = 2338
// module chunks = 0